package pl.michal_cyran.brand_hub.subpages.dayMathAd.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaFirefoxBrowser
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H6
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.HeroButtonsStyle
import pl.michal_cyran.brand_hub.HeroGridStyle
import pl.michal_cyran.brand_hub.components.widgets.DeviceMockup
import pl.michal_cyran.brand_hub.components.widgets.PrimaryButton
import pl.michal_cyran.brand_hub.components.widgets.VisibilityAware
import pl.michal_cyran.brand_hub.components.widgets.revealFadeSlideUp
import pl.michal_cyran.brand_hub.components.widgets.revealFadeSlideUpScale
import pl.michal_cyran.brand_hub.toSitePalette

@Composable
fun DayMathFunctionParameters() {
    val cm = ColorMode.current.toSitePalette()

    SimpleGrid(
        numColumns(base = 1, md = 2),
        HeroGridStyle.toModifier()
    ) {
        VisibilityAware(
            modifier = Modifier
        ) { isVisible ->
            Column(
                modifier = Modifier
            ) {

                H1(
                    Modifier
                        .revealFadeSlideUp(isVisible, delayMs = 120)
                        .toAttrs()
                ) {
                    SpanText(
                        "Odczytywanie własności funkcji",
                        modifier = Modifier
                            .color(cm.textMuted)
                    )
                    Br()
                    SpanText(
                        "z wykresu.",
                        modifier = Modifier
                            .color(cm.primary)
                    )
                }

                P(
                    Modifier
                        .revealFadeSlideUp(isVisible, delayMs = 240)
                        .toAttrs()
                ) {
                    Text(
                        "Naucz się \"czytać\" matematykę. Nasz interaktywny moduł pozwala ćwiczyć rozpoznawanie dziedziny, zbioru wartości, miejsc zerowych i monotoniczności bezpośrednio z dynamicznie generowanych wykresów. "
                    )
                }

                Row(
                    HeroButtonsStyle.toModifier()
                        .revealFadeSlideUp(isVisible, delayMs = 360),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    PrimaryButton(
                        path = "https://lightios.github.io/FunctionSolver/",
                        text = "Zobacz wersję webową",
                        icon = { FaFirefoxBrowser() },
                    )
                }
            }
        }

        VisibilityAware(
            modifier = Modifier.width(100.percent)
        ) { isVisible ->
            Column(
                modifier = Modifier
                    .width(100.percent)
                    .revealFadeSlideUpScale(
                        isVisible,
                        delayMs = 200,
                        distance = 32.px,
                        fromScale = 0.92
                    ),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center,
            ) {
                DeviceMockup("daymath_ss/function_parameters")
            }
        }
    }
}